import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SegmentGroupShopifyMetricsResponseDataSchema } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof SegmentGroupShopifyMetricsResponseDataSchema>>

type Options = {
  id: string
}

export function segmentGroupShopifyMetricsQuery({ id }: Options) {
  return queryOptions({
    queryKey: ["segment-group-shopify-metrics", id],
    queryFn: async () => {
      const response = await axios.get<Response>(`/segments/groups/${id}/shopify-metrics`)

      return response.data.data
    },
  })
}
